export enum ApplicationEventType {
    HideHeader = 'HideHeader',
    AuthenticationRequired = 'LoginRequired'
}